import createSizePropertyCheck from './_createSizePropertyCheck.js';
import getByteLength from './_getByteLength.js';

// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
export default createSizePropertyCheck(getByteLength);



//////////////////
// WEBPACK FOOTER
// /Users/gengis/Documents/WORK/_LOCAL_MAMP/genethon-2020/web/app/themes/genethon/node_modules/underscore/modules/_isBufferLike.js
// module id = 111
// module chunks = 0